import { useRef } from 'react';

import { guessCountry } from '../../helpers';
import ParticipantFieldInputProps from '../ParticipantFieldInputProps';
import UI from '../../UI';
import useProject from '../../useProject';

const PhoneInput = ({
  value, onChange, onBlur, field, registration, touched, errors, validating,
}: ParticipantFieldInputProps) => {
  const idRef = useRef(Math.round(Math.random() * 1000000));
  const project = useProject();

  const country = registration?.details?.country || guessCountry(project) || 'NL';

  return (
    <UI.InputGroup sc={{ valid: !errors?.value, touched }}>
      <UI.InputLabel htmlFor={`Field_${idRef.current}`}>
        {field.title}
        {field.required && (
          <>
            {' '}
            <UI.RequiredMark />
          </>
        )}
      </UI.InputLabel>
      {field.description && (
        <UI.InputDescription as="div">
          <UI.HTML html={field.description} />
        </UI.InputDescription>
      )}
      <UI.PhoneNumberInput
        value={value.value}
        country={country}
        onChange={(value: string) => onChange({ value })}
        onBlur={() => onBlur?.()}
        id={`Field_${idRef.current}`}
      />
      {validating && (
        <UI.Icon>
          <UI.Loader sc={{ brand: 'gray.400' }} />
        </UI.Icon>
      )}
      <UI.ErrorMessages attribute={field.title} errors={errors?.value} />
    </UI.InputGroup>
  );
};

export default PhoneInput;
